import React, {useEffect, useState} from 'react';
import Layout from './layout';
import './scss/withdraw.scss';
import StatusView from './status-view';
import WithdrawForm from './withdraw-form';
import WithdrawTransactions from './withdraw-transactions';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function Withdraw(): React.ReactElement {
    const [statusMessage, setStatusMessage] = useState({message: '', type: StatusMessageTypeEnum.none});

    const urlParams = new URLSearchParams(window.location.search);
    const action = String(urlParams.get('action'));
    let view = <div/>;

    const onStatusMessage = (message: string, type: StatusMessageTypeEnum) => {
        setStatusMessage({message, type});
    };

    if (action === 'form') {
        view = (
            <div>
                <div className="banner"/>
                <WithdrawForm setStatusMessage={onStatusMessage}/>
            </div>
        );
    } else {
        view = (
            <WithdrawTransactions setStatusMessage={onStatusMessage}/>
        );
    }

    useEffect(() => {
    }, []);

    return (
        <Layout className="page withdraw ">
            <StatusView status={statusMessage}/>
            {view}
            <div/>
        </Layout>
    );
}

export default Withdraw;
